import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import { TableOutlined } from '@vicons/antd';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.sort 排序越小越排前
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/airoles',
    name: 'airoles',
    redirect: 'musepose',
    component: Layout,
    meta: {
      title: '自定义角色',
      icon: renderIcon(TableOutlined),
      // permissions: ['dashboard_console', 'dashboard_console', 'dashboard_workplace'],
      sort: 2,
    },
    children: [
      {
        path: 'musepose',
        name: `musepose`,
        meta: { title: '生成情绪和角色' },
        component: () => import('@/views/airoles/musepose/index.vue'),
      },
      {
        path: 'airole',
        name: `airole`,
        meta: { title: '脸部重绘' },
        component: () => import('@/views/airoles/airole/index.vue'),
      },
      {
        path: 'role-list',
        name: `role-list`,
        meta: { title: 'AI角色列表' },
        component: () => import('@/views/airoles/role-list/index.vue'),
      },
      {
        path: 'ai-spine-list',
        name: `ai-spine-list`,
        meta: { title: 'AiSpine角色列表' },
        component: () => import('@/views/airoles/ai-spine-list/index.vue'),
      },
    ],
  },
];

export default routes;
